import HttpClient from "../utils/http-client";

export const CLASSROOM_STATUS_FILTER = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  ALL: "all",
};

export class ClassroomService extends HttpClient {
  async getClassrooms(orgCode, params = {}) {
    const {
      includeChildOrgClassrooms = false,
      status = CLASSROOM_STATUS_FILTER.ACTIVE,
    } = params;

    return await this.http.get(
      `/classroom/organization/${orgCode}/classrooms`,
      {
        params: {
          include_child_org_classrooms: includeChildOrgClassrooms,
          status,
        },
      },
    );
  }
}
